/* istanbul ignore file */
export { default } from './SanityLogo';
